export default __webpack_public_path__ + "static/media/header-img.a8a5bf27.jpg";